/* istanbul ignore file */
import { mainApi } from "config/api";
import { getClientFor } from "infrastructure/http";
import { ILocalizable, commonMessages } from "infrastructure/localization";
import { displayMessages } from "ui/screens/translation-managers/translation-managers.localization";

import { IMessageItem, IMessagesGetRequest } from "./Messages.state";

const getApiProvider = () => {
  const createMessagesSearchRequest = (query: IMessagesGetRequest) => {
    const params = new URLSearchParams();

    query.messageId && params.append("messageId", query.messageId);
    query.text && params.append("text", query.text);
    query.status && query.status.messageId && params.append("status", query.status.messageId.value);
    query.parent && params.append("parent", query.parent.toString());

    return { params };
  };

  return {
    getMessagesStatuses: () => {
      const statuses: ILocalizable[] = [
        { messageId: displayMessages.option("messageStatusNew") },
        { messageId: displayMessages.option("messageStatusPrerelease") },
        { messageId: displayMessages.option("messageStatusPendingRelease") },
        { messageId: displayMessages.option("messageStatusInUse") },
        { messageId: displayMessages.option("messageStatusDeprecated") },
        { messageId: displayMessages.option("messageStatusObsolete") }
      ];

      return statuses;
    },

    getParentOptions: () => {
      const parentOptions: ILocalizable[] = [{ messageId: commonMessages.option("yes") }, { messageId: commonMessages.option("no") }];

      return parentOptions;
    },

    exportMessagesToXml: async (query: IMessagesGetRequest) => {
      const params = new URLSearchParams();

      query.messageId && params.append("messageId", query.messageId);
      query.text && params.append("text", query.text);
      query.status && query.status.messageId && params.append("status", query.status.messageId.value);
      query.parent && params.append("parent", query.parent.toString());

      await getClientFor(mainApi.name).get("/messages/export", { params, responseType: "blob" });
    },

    downloadXmlTemplate: async () => await getClientFor(mainApi.name).get("/messages/template", { responseType: "blob" }),
    getMessages: async (query: IMessagesGetRequest) => (await getClientFor(mainApi.name).get<IMessageItem[]>("/messages", createMessagesSearchRequest(query))).data
  };
};

export const messagesApi = getApiProvider();
